<template>
  <div class="main-menu-list">
    <router-view></router-view>
    <div class="list-header">mixd.tv Services</div>
    <div v-for="(collectionTitle, index) in menuItems" :key="index">
        <ListTextEntry
          v-bind:collectionName=menuItems[index]
          v-bind:selectedEntry=selectedItem
          v-bind:collectionTitle=collectionTitle
          v-on:selected-link="onSelectedCollection"
        >
        </ListTextEntry>
    </div>
  </div>
</template>

<script>
import ListTextEntry from './ListTextEntry.vue'
import Details from './Details.vue'

export default {
  name: 'Header',
  props: [
    'menuItems',
    'selectedItem'
  ],
  components: {
    ListTextEntry,
    Details
  },
  data () {
    return {
      selectedEntry: ''
    }
  },
  watch: {
    selectedTitle: function (val) {
      this.selectedEntry = val
    }
  },
  methods: {
    onSelectedCollection: function (selectedCollectionTitle) {
      /* let collectionIndex = 0
      let selectedCollectionName = '' */

      console.log('-> title ' + selectedCollectionTitle)
      /*
      for (let i = 0; i < this.collectionTitles.length; i = i + 1) {
        console.log('  -> comp.: ' + this.collectionTitles[i])
        console.log('  -> with: ' + selectedCollectionTitle)

        if (this.collectionTitles[i] === selectedCollectionTitle) {
          collectionIndex = i
        }
      }

      selectedCollectionName = this.collectionNames[collectionIndex]
      console.log('-> name ' + selectedCollectionName)
      this.selectedEntry = selectedCollectionTitle */
      this.$emit('selected-link', selectedCollectionTitle)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-menu-list {
  background-color: rgba(255,255,255,0.2);
  width: 140px;
  min-width: 100px;
  margin: 5px;
  margin-left: 0px;
  margin-right: 0px;
  color: #000;
  overflow-y: scroll;
}
.list-header {
  background-color: rgba(255,255,255,0.2);
  font-size: 12px;
}
.v-paginator {
  font-size: 10px;
  padding: 3px;
  background-color: rgba(255,255,255,0.4);
  // background-color: rgba(0,0,0,0.4);
}

.v-paginator >>> .btn{
  font-size: 10px;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainSelectionMenu.vue